import styled from 'styled-components'

const Caption = styled.span`
  display: inline-block;

  color: #a9a9a9;
  font-family: 'Gotham';
  font-size: 12px;
  line-height: 10px;
`

export default Caption



// WEBPACK FOOTER //
// ./src/lib/typography/Caption.jsx